export enum DraftDocumentType {
  RENTAL_CONTRACT_RESIDENTIAL = 'RENTAL_CONTRACT_RESIDENTIAL',
  RENTAL_CONTRACT_RETAIL = 'RENTAL_CONTRACT_RETAIL',
  INGOING_INSPECTION = 'INGOING_INSPECTION',
  JUSTICE_OF_PEACE_REQUEST = 'JUSTICE_OF_PEACE_REQUEST'
}

export enum DraftDocumentStatus {
  DRAFT = 'DRAFT',
  READY_FOR_FINALIZATION = 'READY_FOR_FINALIZATION',
  FINALIZED = 'FINALIZED',
  SENT_TO_ESIGN = 'SENT_TO_ESIGN',
  SENT_FOR_SIGNING = 'SENT_FOR_SIGNING',
  SIGNED = 'SIGNED',
  CANCELLED = 'CANCELLED'
}

export interface DraftDocument {
  id: number;
  contract: {
    id: number;
  };
  documentType: DraftDocumentType;
  status: DraftDocumentStatus;
  title: string;
  draftSharePointFileId?: string;
  draftSharePointFileUrl?: string;
  finalSharePointFileId?: string;
  finalSharePointFileUrl?: string;
  fileLog?: {
    id: number;
    sharePointFileUrl?: string;
  };
  odooSignTemplateId?: string;
  odooSignRequestId?: string;
  odooSignUrl?: string;
  sentForEsignAt?: string;
  signedAt?: string;
  createdBy?: string;
  lastEditedBy?: string;
  lastEditedAt?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateDraftDocumentDto {
  contractId: number;
  unitId: string;
  documentType: DraftDocumentType;
  userId?: string;
}

export interface UpdateDraftDocumentDto {
  title?: string;
  lastEditedBy?: string;
}

export interface FinalizeDraftDocumentDto {
  draftDocumentId: number;
  userId?: string;
}
